import React, { useState } from "react";
import { Button, Form, Spinner } from "reactstrap";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { handlePostApis } from "../../service/Api";
import Head from "../../layout/head/Head";
import Content from "../../layout/content/Content";
import { Block, BlockHeadContent, BlockTitle } from "../../components/Component";

const MIN_LENGTH = 8;
const EMPTY_FORM = { currentPassword: "", newPassword: "", confirmPassword: "" };

const FIELDS = [
  { name: "currentPassword", label: "Current Password", autoComplete: "current-password" },
  { name: "newPassword", label: `New Password (min ${MIN_LENGTH} characters)`, autoComplete: "new-password" },
  { name: "confirmPassword", label: "Confirm New Password", autoComplete: "new-password" },
];

const ChangePassword = () => {
  const [form, setForm] = useState(EMPTY_FORM);
  const [showPasswords, setShowPasswords] = useState(false);
  const [saving, setSaving] = useState(false);

  const handleChange = (e) => setForm({ ...form, [e.target.name]: e.target.value });

  const handleSubmit = async (e) => {
    e.preventDefault();
    const { currentPassword, newPassword, confirmPassword } = form;
    if (!currentPassword || !newPassword) return toast.error("Please fill in all fields");
    if (newPassword.length < MIN_LENGTH) return toast.error(`New password must be at least ${MIN_LENGTH} characters`);
    if (newPassword !== confirmPassword) return toast.error("New passwords do not match");
    if (newPassword === currentPassword) return toast.error("New password must be different from the current one");

    setSaving(true);
    const res = await handlePostApis("admin/change-password", { currentPassword, newPassword });
    setSaving(false);
    if (res?.data?.status) {
      toast.success(res.data.message);
      setForm(EMPTY_FORM);
    } else {
      toast.error(res?.data?.message || "Password could not be changed");
    }
  };

  return (
    <>
      <Head title="Change Password"></Head>
      <ToastContainer position="top-right" autoClose={3000} />
      <Content>
        <Block>
          <BlockHeadContent>
            <BlockTitle page>Change Password</BlockTitle>
          </BlockHeadContent>
          <div className="mt-4" style={{ maxWidth: 480 }}>
            <Form onSubmit={handleSubmit}>
              {FIELDS.map((field) => (
                <div className="form-group" key={field.name}>
                  <label className="form-label" htmlFor={field.name}>{field.label}</label>
                  <input
                    id={field.name}
                    name={field.name}
                    type={showPasswords ? "text" : "password"}
                    autoComplete={field.autoComplete}
                    className="form-control form-control-lg"
                    value={form[field.name]}
                    onChange={handleChange}
                  />
                </div>
              ))}
              <div className="form-group">
                <div className="custom-control custom-checkbox">
                  <input
                    type="checkbox"
                    className="custom-control-input"
                    id="show-passwords"
                    checked={showPasswords}
                    onChange={(e) => setShowPasswords(e.target.checked)}
                  />
                  <label className="custom-control-label" htmlFor="show-passwords">Show passwords</label>
                </div>
              </div>
              <div className="form-group">
                <Button type="submit" color="primary" size="lg" className="btn-block" disabled={saving}>
                  {saving ? <Spinner size="sm" /> : "Update Password"}
                </Button>
              </div>
            </Form>
          </div>
        </Block>
      </Content>
    </>
  );
};

export default ChangePassword;
